/**
 * Booking Constants
 *
 * Business rules for booking hours and limits.
 * Single source of truth for form validation and display.
 */

/** Standard workday hours (default booking size) */
export const DEFAULT_HOURS = 8;

/** Maximum hours allowed with overtime enabled */
export const MAX_HOURS_OVERTIME = 16;

/** Absolute maximum hours per day (24-hour limit) */
export const MAX_HOURS_DAY = 24;
